<template>
    <div>
        <div class="container">
            <p class="title">欢迎您加入e代驾大家庭！</p>
            <ul><li><span>1</span></li><li>请在 e代驾司机信息平台 公众号内完成司机端下载 </li></ul>
            <ul><li><span>2</span></li><li>使用注册手机号登录司机端</li></ul>
            <ul><li><span>3</span></li><li>按照分公司要求在司机端内完成缴费</li></ul>
            <ul><li><span>4</span></li><li>前往分公司领取工装 </li></ul>
            <ul><li><span>5</span></li><li>上线开始工作 </li></ul>

        </div>
         <qrcode class="code"></qrcode>
        <bottom-layout class="buttom_f"></bottom-layout>
    </div>
</template>
<script>
import BottomLayout from './BottomLayout'
import qrcode from '../components/QRcode'
export default {
  components: {
    BottomLayout,
    qrcode
  }
}
</script>
<style lang="scss" scoped>
.container ul:last-child{
    border:none
}
.container{
    background: #f7f7f7;
    font-size: .28rem;
    color: #19191A;
    width: 80%;
    margin-left: 3%;
    padding: 0 7% 0 7%;
    .title{
        text-align: center;
        margin-bottom: .52rem;
        padding-top: .65rem;
    }
    ul li:first-child{
        width: 10%;
        text-align: left;
        float: left;
        span{
            background: #19191A;
            width: .36rem;
            height: .36rem;
            line-height: .36rem;
            border-radius: 50%;
            display: inline-block;
            color: #fff;
            text-align: center;
            position: relative;
            left: -.16rem;
            font-size: .24rem;
        }
    }
    ul li:last-child{
        width: 90%;
        text-align: left;
        float: left;
    }
    li{
        line-height: .36rem;
        display: inline-block;
    }
    ul{
        border-left: 1px #19191a dashed;
        padding-bottom: .52rem;
    }
    ul:after{
        content: '';
        display: block;
        clear: both;
    }
    .tips{
        font-size: .28rem;;
        color: #FF5548;
    }
}
.code{
    margin-bottom: 4rem;
}
.buttom_f{
    position: fixed;
    bottom: .5rem;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/pass-status/components/finish.vue